export default __webpack_public_path__ + "static/media/icon-arrow-down-blue.56652fc9.svg";